export default __webpack_public_path__ + "assets/smartpadel_logo.png";